import script from "./SidenavList.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavList.vue?vue&type=script&setup=true&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=32d6c52d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d6c52d"]])

export default __exports__